<div class="search-bar-container">
    <div class="search-bar">
        <div class="search-tool">
            <input [(ngModel)]="searchText" type="search" [placeholder]="placeHolder" />
            <div class="icon">
                <mat-icon aria-hidden="false" aria-label="keyboard_arrow_right icon" fontIcon="search"></mat-icon>
            </div>
        </div>
    </div>
</div>
